var _rect, _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _path11, _path12, _path13, _path14, _g5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g6, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 101,
    viewBox: "0 0 184 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_158906)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 188,
    height: 104
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.06982,
    y: -1.06982,
    width: 186.14,
    height: 102.698,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_158906)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 188,
    height: 108
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.07 -1.06982H-1.06982V105.372H185.07V-1.06982Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_159_158906)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.787 65.7658L145.664 48.8203C145.439 47.1993 144.186 47.1602 143.129 46.5568C142.914 46.4339 142.733 45.4316 142.733 45.4316L139.468 46.2237C139.468 46.2237 139.702 46.7651 139.135 47.3174C138.517 47.9198 137.519 48.7911 137.614 49.5046L140.086 65.6101C140.086 65.6101 148.121 68.3807 148.787 65.7658Z",
    fill: "#FABAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 44,
    width: 16,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.365 44.3972H127.478V65.6101H142.365V44.3972Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_159_158906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.365 65.6101C142.365 65.6101 141.132 63.2933 138.232 61.7246C138.232 61.7246 134.095 59.7746 132.241 54.2594C132.241 54.2594 132.05 53.7363 132.241 53.0232C132.241 53.0232 133.001 51.6442 131.1 47.4127C129.198 43.1809 128.29 44.4617 127.819 45.0352C126.819 46.2519 128.241 49.974 129.198 52.3101C130.154 54.6458 131.431 56.0184 135.213 62.93C136.804 65.8373 139.223 65.4441 142.365 65.6101Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 41,
    width: 6,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.479 41.5068H138.299V46.8559H143.479V41.5068Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_159_158906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.364 46.1816C142.938 46.0506 139.626 46.0198 139.489 46.6094C139.42 46.9078 138.595 47.0211 138.59 46.4489C138.585 45.9466 138.3 42.5082 138.3 42.5082C138.3 42.5082 138.196 41.9389 140.141 41.624C142.086 41.3086 142.4 41.6841 142.526 42.1099C142.526 42.1099 143.873 46.3382 143.364 46.1816Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.467 51.943C131.686 52.5563 130.33 52.0313 129.194 48.7363C128.058 45.441 128.804 44.1919 130.23 43.7L133.467 51.943Z",
    fill: "#DC0A32"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 63,
    width: 26,
    height: 33
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.395 63.0081H134.702V95.722H159.395V63.0081Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_159_158906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.866 63.4712C159.25 67.4225 159.339 72.6777 159.392 78.1158C159.521 91.1841 155.706 95.6775 146.787 95.7217C137.278 95.7692 134.614 89.7242 134.704 78.828L134.775 63.0081L158.866 63.4712Z",
    fill: "#DC0A32"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.985 44.0125C130.234 43.1653 131.613 44.0555 132.426 45.8114C133.24 47.5675 134.787 51.8054 133.5 51.935C132.212 52.0647 129.557 45.4686 129.985 44.0125Z",
    fill: "#FABAAA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 12,
    width: 33,
    height: 11
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5116 12.7185H47.7555V22.136H15.5116V12.7185Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_159_158906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6597 22.1152C18.4193 20.5967 15.8187 19.2916 15.5197 16.4551C15.2212 13.6186 23.0439 11.347 26.4265 13.694C29.6433 15.9266 32.3963 15.6506 33.7431 14.9366C37.9297 12.7189 46.2477 12.444 47.6282 13.6866C48.3979 14.3792 45.4095 20.5277 45.8925 21.4252C46.376 22.3228 17.6597 22.1152 17.6597 22.1152Z",
    fill: "#F8B9A8"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9812 102.265H47.6281V20.4475H15.9812V102.265Z",
    fill: "#FE7810"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2178 23.6296C38.2178 16.6723 37.1796 5.88319 31.5649 5.88319C25.9545 5.88319 25.8144 21.9227 25.6678 23.6296C25.5218 25.3358 23.4882 25.4958 23.5304 23.6296C23.5722 21.7628 23.0303 3.74365 31.5649 3.74365C40.8997 3.74365 40.2809 22.0308 40.3199 23.6296C40.3579 25.2278 38.2178 25.0689 38.2178 23.6296Z",
    fill: "#AF144B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9071 38.9351L42.5831 28.6466C42.5831 28.6466 50.8814 25.3272 54.2001 29.6421C57.5195 33.957 60.7392 31.2545 62.067 30.2584C63.3941 29.2629 67.8266 26.3484 73.1185 28.3143C85.0222 32.7356 78.2367 38.3518 77.2604 41.876C76.2688 45.4524 44.9071 38.9351 44.9071 38.9351Z",
    fill: "#DC0032"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7208 102.022H80.8041V37.6765H41.7208V102.022Z",
    fill: "#AF144B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5174 40.1537C70.4335 39.793 70.5333 19.2231 60.2626 19.2231C51.6757 19.2231 51.138 39.8888 51.1446 40.0024C50.8731 41.776 48.5987 41.3751 48.5062 40.1537C48.4771 39.6443 48.7328 16.5808 60.2626 16.5808C73.743 16.5808 73.0633 39.9819 73.0944 40.1537C72.807 41.9095 70.8008 41.776 70.5174 40.1537Z",
    fill: "#F8B9A8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 94,
    width: 187,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.534912 94.6743H185.07V101.628H-0.534912V94.6743Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_159_158906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.779 101.382C159.994 101.973 19.2152 101.303 9.27284 101.382C-0.670216 101.461 -0.534864 94.6743 -0.534864 94.6743H184.854C184.854 94.6743 187.563 100.79 173.779 101.382Z",
    fill: "#F8B9A8"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7252 55.0285C95.7252 55.0285 93.7954 48.7441 88.204 49.8209C88.204 49.8209 80.4799 52.7933 78.9756 53.5709C75.2393 55.5019 75.1579 62.6291 75.1035 66.3033C75.0306 71.2382 93.3928 75.6043 95.5302 68.5044C95.5302 68.5044 97.2501 58.0069 95.7252 55.0285Z",
    fill: "#6A3113"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1247 85.5149C91.4468 84.6058 97.5507 80.9157 100.255 79.4853C102.959 78.0551 102.591 76.0165 102.927 72.199C103.005 71.3072 103.372 64.6784 103.579 60.5242C103.579 60.5242 104.143 57.2606 100.55 53.9419L96.0166 49.3809C96.0166 49.3809 78.4557 73.9776 83.2052 80.2489C87.9548 86.5202 90.1247 85.5149 90.1247 85.5149Z",
    fill: "#914420"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4032 68.0007C88.1467 67.1399 88.3616 65.5583 90.248 62.675C90.248 62.675 94.8755 55.7706 95.9691 49.3391C95.9691 49.3391 101.842 55.874 103.44 59.7104C103.726 60.3964 103.512 61.9501 103.493 62.3623C103.299 60.8065 96.2344 58.5325 94.7667 62.3124C93.7138 65.0241 94.8624 65.9152 96.4254 67.4464C98.3822 69.3632 94.1541 71.3799 89.388 69.0015C89.388 69.0015 88.6598 68.8615 88.4032 68.0007Z",
    fill: "#6A3113"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5308 25.551C84.5886 23.9416 86.3017 24.9407 86.6623 25.0892C89.334 26.19 116.363 39.267 119.627 40.8413C121.681 41.8319 121.323 43.6554 120.997 44.3441C117.81 51.0831 112.64 62.0484 112.081 62.8679C111.605 63.5662 111.11 65.0539 108.707 63.8949C99.4017 59.407 84.7968 52.3751 75.4919 47.8876C74.6033 47.4591 73.4676 46.4995 74.4214 44.5218C76.7482 39.6973 82.667 26.8654 83.5308 25.551Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6006 35.0467C91.0098 36.1445 90.4376 36.2565 89.2733 35.7529C88.0125 35.2075 86.6039 34.5346 85.0895 33.6816C84.729 33.4785 83.934 32.8694 84.4157 31.6161C84.6394 31.0338 85.1139 30.0978 85.4122 29.5499C85.961 28.542 86.4717 28.2616 87.2839 28.4676C88.1865 28.6966 91.228 30.236 91.6822 30.4788C93.1391 31.2578 92.8593 32.2662 92.6717 32.8117C92.4076 33.5794 91.9855 34.3318 91.6006 35.0467Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3255 42.8827C79.043 43.4402 78.7806 43.8098 78.8914 44.1803C79.1362 44.9989 80.6019 45.6229 81.1973 44.5913C81.7279 43.672 81.837 42.4909 81.1987 42.1535C80.5604 41.8162 79.8521 41.844 79.3255 42.8827Z",
    fill: "#FE7810"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.377 55.4466C105.095 56.004 104.832 56.3736 104.943 56.7442C105.188 57.5627 106.654 58.1869 107.249 57.1553C107.78 56.236 107.889 55.0548 107.25 54.7175C106.612 54.3801 105.904 54.408 105.377 55.4466Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.69 58.8612C109.943 58.6574 110.163 58.2579 110.312 57.9487C110.652 57.2456 110.615 56.7162 109.734 56.2914C108.853 55.8667 108.416 56.1674 108.144 56.7307C108.077 56.8702 108.039 56.9937 107.994 57.1754C107.705 58.3468 109.409 59.0879 109.69 58.8612Z",
    fill: "#FE7810"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2321 46.4287C83.922 46.3382 83.5085 46.2174 83.1099 46.0251C82.1532 45.5638 81.9006 45.0684 82.2161 44.4145C82.5469 43.7286 82.9833 43.8013 83.8039 44.1381L85.0861 44.6581C86.3111 45.1024 84.2321 46.4287 84.2321 46.4287Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.142 54.0259C102.427 53.4236 102.675 53.1475 102.675 53.1475C103.165 53.2247 103.656 53.4285 104.025 53.5694C104.757 53.8498 105.505 54.1385 104.911 55.3616C104.318 56.5849 103.924 56.9391 103.091 56.1822C102.259 55.4252 101.857 54.6282 102.142 54.0259Z",
    fill: "#FE7810"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8136 51.1201C99.0231 51.1676 99.2262 51.2238 99.4356 51.3247C100.005 51.5993 100.154 51.9893 99.7434 52.84C99.3331 53.6908 98.9353 53.8172 98.366 53.5426C98.176 53.451 98.02 53.3478 97.8178 53.1847C96.6707 52.2667 98.8136 51.1201 98.8136 51.1201Z",
    fill: "#FE7810"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8895 47.6855C90.4313 47.0335 88.7942 46.1926 87.9641 47.4725C87.4044 48.3354 88.3304 49.0978 91.147 50.4561C92.4534 51.0862 93.7578 51.6592 94.6238 52.1331C95.6399 52.6887 96.897 52.9218 97.1079 51.2487C97.2545 50.0868 94.7785 48.9774 91.8895 47.6855Z",
    fill: "#FE7810"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.523 47.7593C115.371 50.1486 112.5 51.1517 110.112 49.9998C107.723 48.8478 106.721 45.9772 107.874 43.588C109.026 41.1988 111.896 40.1955 114.285 41.3475C116.673 42.4993 117.675 45.3701 116.523 47.7593Z",
    fill: "#FE7810"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_159_158906",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 45,
    width: 52,
    height: 64
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3147 45.3953H45.8723V108.385H96.3147V45.3953Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_159_158906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3881 69.0014C87.5401 67.9221 88.3182 66.2947 89.193 64.5701C89.193 64.5701 92.8387 58.5571 94.6487 54.3131C96.3925 50.2242 97.6162 47.3375 93.8217 45.7834C90.0273 44.2293 88.6539 47.568 86.4924 51.7799C84.5224 55.6187 83.7363 60.8396 79.3922 63.0514C75.048 65.2631 70.62 70.628 67.8728 79.347C67.8728 79.347 66.0506 85.9327 63.3002 89.7999C63.3002 89.7999 48.6708 107.518 46.2239 110.507C46.2239 110.507 43.9369 116.39 51.0282 114.255L69.8325 110.741C69.6703 110.475 74.2209 99.9261 78.1612 95.0777C78.1612 95.0777 82.8369 90.5263 90.1247 85.5149L89.3881 69.0014Z",
    fill: "#914420"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1731 46.2581C91.1731 46.2581 92.5423 46.047 93.9113 46.713C95.2802 47.379 95.5822 48.6581 95.5822 48.6581C95.5822 48.6581 93.981 53.5576 90.8627 52.3995C87.7444 51.2414 91.1731 46.2581 91.1731 46.2581Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_158906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 100.558,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.8ed07691c1825af337861bc46ec03a22.svg";
export { ForwardRef as ReactComponent };